import React, { useState } from "react";
import _ from "lodash";
import SaveIcon from "@mui/icons-material/SaveRounded";
import CloseIcon from "@mui/icons-material/CloseRounded";
import { Button, Modal, Row, Col } from "react-bootstrap";
import "../../pages/_Components/ReactBeautifulDnd.css";
import { DragDropContext, Draggable } from "react-beautiful-dnd";
import StrictModeDroppable from "../_Components/StrictModeDroppable";

const ChangeOrderPhones = ({ showModalPhoneOrder, setShowModalPhoneOrder, phone, setPhone }) => {
  const [phones, setPhones] = useState(phone.phones);

  const handleDragEnd = (result) => {
    if (!result.destination) return;

    const updatedPhones = Array.from(phones);
    const [reorderedPhone] = updatedPhones.splice(result.source.index, 1);
    updatedPhones.splice(result.destination.index, 0, reorderedPhone);

    setPhones(updatedPhones);
  };
  const handleClose = () => {
    setShowModalPhoneOrder(false);
  };
  const doneSortedPhones = async () => {
    try {

      setPhone(prev => {
        return {
          ...prev,
          phones,
          isChangedOrder: true
        }
      })
      // ارسال درخواست به سرور
      setShowModalPhoneOrder(false);
    } catch (error) {
    }
  };

  return (
    <div>
      <div className="card-body pt-3 pb-0">
        {/* Start Modal */}
        <Modal centered size="md" show={showModalPhoneOrder} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>ترتیب قرارگیری شماره های تلفن</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <DragDropContext onDragEnd={handleDragEnd}>
              <StrictModeDroppable droppableId="droppable">
                {(provided) => (
                  <ul className="sortable-list" {...provided.droppableProps} ref={provided.innerRef}>
                    {phones.map((item, index) => (
                      <Draggable key={`${item.title}_${item.phone}`} draggableId={`${item.title}_${item.phone}`} index={index}>
                        {(provided) => (
                          <li
                            className="sortable-item"
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                          >
                            <Row style={{ fontSize: 12 }} className="fw-bold px-5 mb-2">اولویت {index + 1}</Row>
                            <Row className="justify-content-between">
                              <Col>عنوان: {item.title}</Col>
                              <Col xs="5" md="4">تلفن: {item.phone}</Col>
                            </Row>
                          </li>
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </ul>
                )}
              </StrictModeDroppable>
            </DragDropContext>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="success" onClick={doneSortedPhones}>
              <SaveIcon /> ذخیره
            </Button>
            <Button variant="danger" onClick={handleClose}>
              <CloseIcon /> بستن
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </div>
  );
};
export default ChangeOrderPhones;
